///ts:ref=PandaConsole
/// <reference path="../console/PandaConsole.ts"/> ///ts:ref:generated
namespace WebGLUtils {
	export function getGLContext(canvas:HTMLCanvasElement, attributes:WebGLContextAttributes = null):WebGLRenderingContext {
		PandaConsole.here;
		if (!canvas) {
			return null;
		}
		try {
			if (!canvas.getContext) {
				PandaConsole.logDebug('WebGLUtils::getGLContext: getContext is not supported');
				return null;
			}
			let context = canvas.getContext("webgl", attributes) || canvas.getContext("experimental-webgl", attributes);
			return context as WebGLRenderingContext;
		} catch (e) {
			PandaConsole.errorUncritical(e);
		}
		return null;
	}

	export function getDummyCanvas():HTMLCanvasElement {
		return document.createElement('canvas');
	}
	export function getDummyContext():WebGLRenderingContext {
		return getGLContext(getDummyCanvas());
	}

	export function getExtension(context:WebGLRenderingContext, name: "ANGLE_instanced_arrays"): ANGLEInstancedArrays;
	export function getExtension(context:WebGLRenderingContext, name: "EXT_blend_minmax"): EXTBlendMinMax;
	export function getExtension(context:WebGLRenderingContext, name: "EXT_color_buffer_half_float"): EXTColorBufferHalfFloat;
	export function getExtension(context:WebGLRenderingContext, name: "EXT_frag_depth"): EXTFragDepth;
	export function getExtension(context:WebGLRenderingContext, name: "EXT_sRGB"): EXTsRGB;
	export function getExtension(context:WebGLRenderingContext, name: "EXT_shader_texture_lod"): EXTShaderTextureLOD;
	export function getExtension(context:WebGLRenderingContext, name: "EXT_texture_filter_anisotropic"): EXTTextureFilterAnisotropic;
	export function getExtension(context:WebGLRenderingContext, name: "OES_element_index_uint"): OESElementIndexUint;
	export function getExtension(context:WebGLRenderingContext, name: "OES_standard_derivatives"): OESStandardDerivatives;
	export function getExtension(context:WebGLRenderingContext, name: "OES_texture_float"): OESTextureFloat;
	export function getExtension(context:WebGLRenderingContext, name: "OES_texture_float_linear"): OESTextureFloatLinear;
	export function getExtension(context:WebGLRenderingContext, name: "OES_texture_half_float"): OESTextureHalfFloat;
	export function getExtension(context:WebGLRenderingContext, name: "OES_texture_half_float_linear"): OESTextureHalfFloatLinear;
	export function getExtension(context:WebGLRenderingContext, name: "OES_vertex_array_object"): OESVertexArrayObject;
	export function getExtension(context:WebGLRenderingContext, name: "WEBGL_color_buffer_float"): WebGLColorBufferFloat;
	export function getExtension(context:WebGLRenderingContext, name: "WEBGL_compressed_texture_atc"): WebGLCompressedTextureATC;
	export function getExtension(context:WebGLRenderingContext, name: "WEBGL_compressed_texture_etc1"): WebGLCompressedTextureETC1;
	export function getExtension(context:WebGLRenderingContext, name: "WEBGL_compressed_texture_pvrtc"): WebGLCompressedTexturePVRTC;
	export function getExtension(context:WebGLRenderingContext, name: "WEBGL_compressed_texture_s3tc"): WebGLCompressedTextureS3TC;
	export function getExtension(context:WebGLRenderingContext, name: "WEBGL_debug_renderer_info"): WebGLDebugRendererInfo;
	export function getExtension(context:WebGLRenderingContext, name: "WEBGL_debug_shaders"): WebGLDebugShaders;
	export function getExtension(context:WebGLRenderingContext, name: "WEBGL_depth_texture"): WebGLDepthTexture;
	export function getExtension(context:WebGLRenderingContext, name: "WEBGL_draw_buffers"): WebGLDrawBuffers;
	export function getExtension(context:WebGLRenderingContext, name: "WEBGL_lose_context"): WebGLLoseContext;
	export function getExtension(context:WebGLRenderingContext, name: "EXT_frag_depth"): EXTFragDepth;
	export function getExtension(context:WebGLRenderingContext, name: "WEBGL_depth_texture"): WebGLDepthTexture;
	export function getExtension(context:WebGLRenderingContext, name: string):any;
	export function getExtension(context:WebGLRenderingContext, name: string):any {
		PandaConsole.here;
		if (!context) {
			return null;
		}
		try {
			let extension:any = context.getExtension(name);
			if (extension) {
				return extension;
			} else {
				for (let prefix of browserPrefixes) {
					extension = context.getExtension(prefix + name);
					if (extension) {
						return extension;
					}
				}
			}
		} catch (e) {
			PandaConsole.errorUncritical(e);
		}
		return null;
	}

	const browserPrefixes = ['MOZ_', 'WEBKIT_'];

	export namespace extensions {
		export const ANGLE_instanced_arrays:'ANGLE_instanced_arrays' = 'ANGLE_instanced_arrays';
		export const OES_texture_float:'OES_texture_float' = 'OES_texture_float';
		export const OES_texture_float_linear:'OES_texture_float_linear' = 'OES_texture_float_linear';
		export const EXT_texture_filter_anisotropic:'EXT_texture_filter_anisotropic' = 'EXT_texture_filter_anisotropic';
		export const OES_standard_derivatives:'OES_standard_derivatives' = 'OES_standard_derivatives';
		export const OES_element_index_uint:'OES_element_index_uint' = 'OES_element_index_uint';
	}

	export namespace optionalExtensions {
		export const WEBGL_debug_renderer_info:'WEBGL_debug_renderer_info' = 'WEBGL_debug_renderer_info';
		export const WEBGL_compressed_texture_s3tc:'WEBGL_compressed_texture_s3tc' = 'WEBGL_compressed_texture_s3tc';
		export const WEBGL_compressed_texture_pvrtc:'WEBGL_compressed_texture_pvrtc' = 'WEBGL_compressed_texture_pvrtc';
		export const WEBGL_lose_context:'WEBGL_lose_context' = 'WEBGL_lose_context';
		export const EXT_frag_depth:'EXT_frag_depth' = 'EXT_frag_depth';
		export const WEBGL_depth_texture:'WEBGL_depth_texture' = 'WEBGL_depth_texture';
		export const OES_vertex_array_object:'OES_vertex_array_object' = 'OES_vertex_array_object';
	}
}